import React, { useState } from "react";
import "../Assets/css/index.css";
import axiosMain from "../http/axiosMain";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  Link,
  Avatar,
  Button,
  Divider,
  Paper,
} from "@mui/material";
import DeleteAccountModal from "./DeleteAccountModal";

const AccountSetting = () => {
  const navigate = useNavigate();
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const handleDeleteClick = () => {
    setIsDeleteModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsDeleteModalOpen(false);
  };

  const handleConfirmDelete = async () => {
    try {
      const response = await axiosMain.put(`/api/v1/delete-user`);
      if (response.status === 200) {
        localStorage.clear();
        sessionStorage.removeItem("email");
        sessionStorage.removeItem("phone_no");
        localStorage.setItem("openModal", "true");
        navigate("/signUp");
        window.location.reload();
      }
    } catch (error) {
      console.error("Error deleting account:", error);
      alert("Failed to delete account. Please try again.");
    } finally {
      setIsDeleteModalOpen(false);
    }
  };

  return (
    <Box className="settings-container" mt={1}>
      <Box mb={3}>
        <Typography variant="subtitle1" fontWeight="bold">
          Change Email Address
        </Typography>
        <Typography variant="body2">
          To change your email address please mail on{" "}
          <Link
            href="mailto:support@insocialorbit.com"
            sx={{ color: "rgba(107, 142, 118, 1)" }}
          >
            support@insocialorbit.com
          </Link>
        </Typography>
      </Box>
      <Divider
        sx={{ my: 3, height: 2, backgroundColor: "rgba(221, 221, 221, 1)" }}
      />
      <Box mb={3}>
        <Typography variant="subtitle1" fontWeight="bold">
          Change Phone Number
        </Typography>
        <Typography variant="body2" color="text.secondary">
          To change your phone number please mail on{" "}
          <Link
            href="mailto:support@insocialorbit.com"
            sx={{ color: "rgba(107, 142, 118, 1)" }}
          >
            support@insocialorbit.com
          </Link>
        </Typography>
      </Box>
      <Divider
        sx={{ my: 3, height: 2, backgroundColor: "rgba(221, 221, 221, 1)" }}
      />
      <Box>
        <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
          Login Activity
        </Typography>
        <Typography variant="body2" color="text.secondary" mb={2}>
          View recent login activity to monitor unauthorized access or
          suspicious behavior.
        </Typography>
        {[...Array(5)].map((_, index) => (
          <Paper
            key={index}
            elevation={0}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              border: "1px solid #e0e0e0",
              borderRadius: 2,
              p: 2,
              mb: 1.5,
              mt: 1,
            }}
          >
            <Box display="flex" alignItems="center">
              <Avatar sx={{ width: 40, height: 40, bgcolor: "#ddd", mr: 2 }} />
              <Box>
                <Typography variant="body1" fontWeight="500">
                  Login From RMX-132
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Ahmedabad, India - at 10:30 AM
                </Typography>
              </Box>
            </Box>
            <Button
              disableRipple
              sx={{
                border: "none !important",
                boxShadow: "none !important",
                color: "rgba(199, 27, 27, 1)",
                textTransform: "none",

                fontWeight: 500,
              }}
            >
              Logout
            </Button>
          </Paper>
        ))}
      </Box>
      <Divider
        sx={{ my: 3, height: 2, backgroundColor: "rgba(221, 221, 221, 1)" }}
      />
      <Box>
        <Typography
          variant="body1"
          color="error"
          fontWeight="bold"
          sx={{ cursor: "pointer" }}
          onClick={handleDeleteClick}
        >
          Delete Account
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Permanently close your account.
        </Typography>
      </Box>
      <DeleteAccountModal
        open={isDeleteModalOpen}
        onConfirm={handleConfirmDelete}
        onClose={handleCloseModal}
      />
    </Box>
  );
};

export default AccountSetting;
